export default "__VITE_ASSET__799077e1__"